import { MarkedExtension } from 'marked';

export function headingIdsExtension(): MarkedExtension {
  return {
    renderer: {
      heading(text: string, depth: number): string {
        // Generate slug from heading text
        const slug = text
          .toLowerCase()
          .trim()
          .replace(/[^\w\s-]/g, '')
          .replace(/[\s_-]+/g, '-')
          .replace(/^-+|-+$/g, '');

        // Get current path and search params to preserve them in anchor links
        const currentPath = typeof window !== 'undefined'
          ? window.location.pathname + window.location.search
          : '';

        return `
          <h${depth} id="${slug}" class="markdown-heading">
            <a href="${currentPath}#${slug}" class="markdown-heading-anchor" aria-hidden="true">#</a>
            <span>${text}</span>
          </h${depth}>
        `;
      }
    }
  };
}
